<h3>AI Q&amp;A</h3>

<p>
  Ask questions against your uploaded documents.
  If you haven’t uploaded yet, go to <a routerLink="/jfriedman/aiupload">AI Upload</a>.
</p>

<div *ngIf="error" class="alert alert-danger">{{ error }}</div>

<div class="chat">
  <div class="msg" *ngFor="let m of messages" [class.user]="m.role === 'user'" [class.assistant]="m.role === 'assistant'">
    <div class="role">{{ m.role }}</div>
    <div class="text">{{ m.text }}</div>
  </div>
</div>

<div class="composer">
  <textarea class="form-control" rows="3" [(ngModel)]="question" [disabled]="busy" placeholder="Ask a question..."></textarea>
  <div class="composer-actions">
    <button class="btn btn-primary" (click)="ask()" [disabled]="busy || !question.trim()">
      <span *ngIf="busy"><i class="fas fa-spinner fa-spin"></i> Asking...</span>
      <span *ngIf="!busy"><i class="fas fa-paper-plane"></i> Ask</span>
    </button>
  </div>
</div>

